import { Permissions } from '../../models/enums/permissions';
import * as React from 'react';
import { HasPermission } from '../../containers/authorization-helpers/HasPermission';
import { InsertMethod } from '../models/enums/insert-method';

interface IProps {
    hasCutRowsPending: boolean;
    insertRows: any;
    cancelSelectedRows: any;
    clearSelections: any;
    completeSelectedRows: any;
    cutRows: any;
    rowCount: number;
    heightOffset: number;
    insertPoint: number;
    viewDetails: any;
    printAllJobs?: any;
    completeAllSelections?: any;
    printPaperwork?: any;
}

export const RunRightClickMenu = (props : IProps) => {
    return (
        <div>
            <p>Run Actions</p>

            <HasPermission requiredPermissions={[
                Permissions.ProductionScheduleSort
            ]}>
                {
                    props.hasCutRowsPending && props.insertPoint >= 0
                        ? <React.Fragment>
                            <button onClick={ () => props.insertRows(InsertMethod.Above) }>
                                <i className="la la-indent" />
                                Insert { props.rowCount - 1 } Rows Above
                            </button>
                            <button onClick={ () => props.insertRows(InsertMethod.Below) }>
                                <i className="la la-indent" />
                                Insert { props.rowCount - 1 } Rows Below
                            </button>
                            <div className="right-click-divide" />
                        </React.Fragment>
                        : null
                }
                {
                    !props.hasCutRowsPending
                        ? <React.Fragment>
                            <button onClick={ props.cutRows }>
                                <i className="la la-scissors" />
                                Cut { props.rowCount } Rows
                            </button>
                            <div className="right-click-divide" />
                        </React.Fragment>
                        : null
                }
            </HasPermission>

            {
                !props.hasCutRowsPending
                    ? <React.Fragment>

                        {
                            props.rowCount === 1
                                ? <HasPermission requiredPermissions={[
                                    Permissions.ProductionScheduleView
                                ]}>
                                    <button onClick={ props.printPaperwork }>
                                        <i className="la la-download"/>
                                        Download Paperwork
                                    </button>
                                </HasPermission>
                                : null
                        }

                        <HasPermission requiredPermissions={[
                            Permissions.ProductionScheduleJobs
                        ]}>
                            <button onClick={ props.printAllJobs }>
                                <i className="la la-print"/>
                                Print Job(s)
                            </button>
                        </HasPermission>

                        <HasPermission requiredPermissions={[
                            Permissions.ProductionScheduleJobs
                        ]}>
                            <button onClick={ props.completeAllSelections }>
                                <i className="la la-check-circle"/>
                                Complete Job(s)
                            </button>
                        </HasPermission>

                        <div className="right-click-divide" />

                        <HasPermission requiredPermissions={[
                            Permissions.ProductionScheduleRuns
                        ]}>
                            <button onClick={ props.completeSelectedRows }>
                                <i className="la la-check-circle"/>
                                Complete Run(s)
                            </button>
                        </HasPermission>

                        <HasPermission requiredPermissions={[
                            Permissions.ProductionScheduleRuns
                        ]}>
                            <button onClick={ props.cancelSelectedRows }>
                                <i className="la la-ban"/>
                                Cancel Run(s)
                            </button>
                        </HasPermission>

                        <div className="right-click-divide" />

                    </React.Fragment>
                    : null
            }

            {
                props.rowCount === 1
                    ? <HasPermission requiredPermissions={[
                        Permissions.ProductionScheduleView,
                        Permissions.ProductionScheduleRsView
                    ]}>
                        <button onClick={ props.viewDetails }>
                            <i className="la la-eye"/>
                            View Orders
                        </button>
                    </HasPermission>
                    : null
            }
        
            <button onClick={ props.clearSelections }>
                <i className="la la-eraser"/>
                Clear Selections
            </button>
        </div>
    );
};
